import KlimaSlider from "./klimaSlider/KlimaSlider";
import { observer } from "mobx-react";
import RootStore from "SandboxViewerComponent/src/stores/RootStore";
import { styled } from "@mui/material";

const SliderWrapper = styled("div", {
  shouldForwardProp: (key) => key !== "mobile" && key !== "visible",
})(({ mobile, visible }) => ({
  display: visible ? "block" : "none", // nur, wenn auch die Attributauswahl angezeigt wird
  position: "absolute",
  bottom: mobile ? undefined : 15,
  top: mobile ? 15 : undefined,
  // Mobile: fixed width, centered via transform
  // Desktop: stretch left→right, auto-margin centres fit-content child; avoids viewport clipping
  ...(mobile
    ? {
        width: 245,
        left: "50%",
        transform: "translateX(-50%)",
        background: "#FFF",
      }
    : {
        left: 0,
        right: 0,
        margin: "0 auto",
        width: "fit-content",
        maxWidth: "calc(100% - 16px)",
      }),
  height: "auto",
  boxSizing: "border-box",
  userSelect: "none",
  MozUserSelect: "none",
  msUserSelect: "none",
  WebkitUserSelect: "none",
}));

/**
 * KlimaSlider wrapper component.
 * @param {object} CommunicationStore vom Sandboxviewer
 * @param {string} attributeId welches im Klimaslider angezeigt werden soll
 * @param {string} token vom Sandboxviewer
 * @param {object} view vom Sandboxviewer
 * @param {object} map vom Sandboxviewer
 * @returns {string} attributeId
 */
const KlimaSliderWrapper = (props) => {
  const { CommunicationStore, attributeId, token, view, map } = props;
  const mobile = RootStore.uiStore.BBStore.mobile;

  // filterChoices must remain () => true here.
  // LayerFilter computes `index` as an index into the UNFILTERED choices array.
  // KlimaSlider uses `selected` as an index into `originalItems` (= the mapped items array).
  // Both arrays are only equivalent when filterChoices passes everything through.
  // If filterChoices ever filters items out, index and items would be misaligned.
  const filterChoices = (c) => {
    return true;
  };

  // Get Zeitraum data
  const filterAccess =
    CommunicationStore.getMessagesToID({
      to: "filterAccess",
    })?.message(attributeId, filterChoices) || {};
  const {
    items = [],
    index,
    setIndex = () => {},
    visible = false,
  } = filterAccess;

  // Get Szenario data
  const szenarioAccess =
    CommunicationStore.getMessagesToID({
      to: "filterAccess",
    })?.message("Szenario", filterChoices) || {};
  const {
    items: szenarioItems = [],
    index: szenarioIndex,
    setIndex: setSzenarioIndex = () => {},
  } = szenarioAccess;

  return (
    <SliderWrapper id="klimaSlider" mobile={mobile} visible={visible}>
      <KlimaSlider
        selected={index}
        setSelected={setIndex}
        mobile={mobile}
        items={items.map(
          (
            {
              label,
              value,
              short,
              projection = false,
              nopossibilities,
              excludeInSlider = false,
            } //ziemlich auf den Filter gematched: Die anzeigewerte sind die label der updatevalues des dropdowns zur ID
          ) => {
            return {
              label: short ? short : label,
              projection: projection,
              used: nopossibilities > 0,
              excludeInSlider,
            };
          } //(short ? short : label)
        )}
        szenarioItems={szenarioItems
          .filter(({ label }) => label && label.toLowerCase() !== "skip")
          .map(({ label, short, excludeInSlider = false }) => {
            return {
              label: short ? short : label,
              excludeInSlider,
            };
          })}
        szenarioIndex={szenarioIndex}
        setSzenarioIndex={setSzenarioIndex}
        CommunicationStore={CommunicationStore}
        token={token}
        view={view}
        map={map}
      />
    </SliderWrapper>
  );
};

export default observer(KlimaSliderWrapper);
